<template>
  <div id="app" data-app class="dvLogin animate1 fadeIn">
    <div class="dvModals">

      <div id="modal-forgot-password" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Password Reset
          </div>
          <a ref="modalBtnClose" class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javaScript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">ENTER YOUR EMAIL ADDRESS</label>
                <input v-model="requestPassword.email" class="browser-default defaultModal-input" placeholder="Enter your email address" type="text" />
                <div class="defaultModal-helper-text">
                  * A new password will be sent to the registered email
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            @click="requestNewPassword()"
            href="javascript:void(0)"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check" v-if="!loadingNewPass"></span>
            {{ loadingNewPass ? 'Please wait...' : '' }}
            {{ !loadingNewPass ? 'Reset' : '' }}
          </a>
          <a href="javaScript:void(0)" class="modal-close waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>

        </div>
      </div><!-- modal-->

    </div>



    <div class="dvLogin-container">
      <div class="dvLogin-content animate2 fadeInUp">
        <div class="dvLogin-card">
          <div class="dvLogin-card-content">

            <div class="dvLogin-card-content_logo">
              <img src="@/assets/svg/alisi-firststep-logo.svg"/>
            </div>

            <div class="dvLogin-card-content_head">
              Log in to your account
            </div>

            <div class="dvLogin-card-content_avatar">
              <div class="dvLogin-card-content_avatar-placer flexCenterAll"><span class="icon-fs_user"></span></div>
              <img class="dvLogin-card-content_avatar-pic responsive-img hide" src="@/assets/images/temp-user.jpg"/>
            </div>

            <form ref="observer">
              <div class="dvLogin-form">
                <input type="text" style="display:none">
                <input type="password" style="display:none">
                <input v-model="user.username" placeholder="Enter your registered email" type="email" autocomplete="off"/>
                <input v-model="user.password" placeholder="Enter your password" type="password" autocomplete="off"/>
              </div>

              <a href="javascript:void(0)" class="dvLogin-card-content_btn flexCenterAll" @click="submit()">
                <div class="dvLogin-card-content_btn-content">
                  {{ loading ? 'Please wait...' : '' }}
                  {{ !loading ? 'Submit' : '' }}
                </div>
                <div class="dvLogin-card-content_btn-bg waves-effect waves-light hvr-grow-shadow"></div>
              </a>
            </form>

            <div class="dvLogin-card-content_helper">
              <a @click="showModal('modal-forgot-password')" href="javascript:void(0)">Forgot password?</a>
            </div>

          </div>
        </div>
        <div class="dvLogin-links">
          <a href="/terms-of-use">Terms of Use</a>
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/contact-us">Contact Us</a>
        </div>
      </div>

      <div class="dvLogin-footer">
        <img src="@/assets/svg/ali-logo.svg"/>
        <div>
          © 2022 All Rights Reserved.
        </div>
      </div>
    </div>

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
  </div>
</template>

<script>
import SnackBar from '@/components/snackbar/SnackBar.vue'
import M from 'materialize-css'

export default {
  name: 'App',
  data: () => ({
    email: '',
    user: {
      username: '',
      password: ''
    },
    requestPassword: {
      email: ''
    },
    snackbarDetails: {
      msg: '',
      show: false,
      timeout: 10000,
      color: 'sb-success'
    },
    loading: false,
    loadingNewPass: false
  }),
  computed: {
    checkIcon(){
      let retVal = ''
      if(this.snackbarDetails.color == 'sb-success'){
        retVal = 'icon-action_check_circle'
      }else if(this.snackbarDetails.color == 'sb-pending'){
        retVal = 'icon-content_status'
      }else if(this.snackbarDetails.color == 'sb-failed'){
        retVal = 'icon-action_close'
      }
      return retVal
    }
  },
  methods: {
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    requestNewPassword (){
      if (this.requestPassword.email == '') {
        this.showMessage('Email is required.', 'sb-failed')
        return false
      }

      if (!this.validateEmail(this.requestPassword.email.trim())){
        this.showMessage('Invalid email address.', 'sb-failed')
        return false
      }

      if(this.loadingNewPass){
        return false;
      }

      this.loadingNewPass = true
      let self = this

      this.$http.secured.post('request-new-password', this.requestPassword)
        .then(response => {
          // console.log(response.data)
          const elem = this.$refs.modalBtnClose
          elem.click()
          this.showMessage(response.data.message, 'sb-success')
        })
        .catch(error => {
          if (error.response) {
            let errors = error.response.data.messages
            let msg = []
            // alert(error.response.data.messages)
            Object.keys(errors).forEach(key => {
              msg.push(errors[key])
            })
            this.showMessage(msg.join(','), 'sb-failed')

            Object.keys(this.user).forEach(key => {
              this.user[key] = ''
            })

            this.$refs.observer.reset()

          }else{
            this.showMessage("Something went wrong! Please try again.", 'sb-failed')
          }
        })
        .then(function () {
          self.loadingNewPass = false
        })
    },
    showModal (str){
      const elem = document.getElementById(str);
      const instance = M.Modal.init(elem, {dismissible: false});
      instance.open();
      this.requestPassword.email = ''
      // this.referralfile = ''
    },
    closeModal (str){
      const elem = document.getElementById(str);
      const instance = M.Modal.init(elem, {dismissible: false});
      instance.close();
    },
    submit () {

      if (this.user.username == '') {
        this.showMessage('Please enter your registered email.', 'sb-failed')
        return false
      }

      if (this.user.password == '') {
        this.showMessage('Password is required.', 'sb-failed')
        return false
      }

      if(this.loading){
        return false;
      }

      this.loading = true
      let self = this

      this.$http.secured.post('authenticate', this.user)
        .then(response => {
          window.location.href = '/signin?id=' + response.data.id + '&access_token=' + response.data.access_token
        })
        .catch(error => {
          if (error.response) {
            let errors = error.response.data.messages
            let msg = []
            // alert(error.response.data.messages)
            Object.keys(errors).forEach(key => {
              msg.push(errors[key])
            })
            this.showMessage(msg.join(','), 'sb-failed')

            Object.keys(this.user).forEach(key => {
              this.user[key] = ''
            })

            this.$refs.observer.reset()

          }else{
            this.showMessage("Something went wrong! Please try again.", 'sb-failed')
          }
        })
        .then(function () {
          self.loading = false
        })
    },
    showMessage(msg, color){
      this.snackbarDetails = {
        color: color,
        msg: msg,
        show: true
      }
    }
  },
  components: {
    SnackBar
  },
  mounted () {
    this.$store.commit('setApiUrl', { url: process.env.VUE_APP_API_URL })
    this.$store.commit('resetRefreshCnt')
    M.AutoInit()
  }
}
</script>
